// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file cortado/v1/agent.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import { AgentService } from "./agent_pb";

/**
 * @generated from rpc cortado.v1.AgentService.ExecuteAction
 */
export const executeAction = AgentService.method.executeAction;

/**
 * @generated from rpc cortado.v1.AgentService.RejectAction
 */
export const rejectAction = AgentService.method.rejectAction;

/**
 * GetAgentHistory is superseded by ListAgentSessions/GetAgentSession and
 * always returns Unimplemented. Kept in the proto so old clients fail
 * loudly instead of breaking at decode time. Removed once callers migrate.
 *
 * @generated from rpc cortado.v1.AgentService.GetAgentHistory
 * @deprecated
 */
export const getAgentHistory = AgentService.method.getAgentHistory;

/**
 * @generated from rpc cortado.v1.AgentService.ListAgentSessions
 */
export const listAgentSessions = AgentService.method.listAgentSessions;

/**
 * @generated from rpc cortado.v1.AgentService.GetAgentSession
 */
export const getAgentSession = AgentService.method.getAgentSession;

/**
 * @generated from rpc cortado.v1.AgentService.GetAgentTurn
 */
export const getAgentTurn = AgentService.method.getAgentTurn;

/**
 * @generated from rpc cortado.v1.AgentService.ListAgentApprovals
 */
export const listAgentApprovals = AgentService.method.listAgentApprovals;

/**
 * @generated from rpc cortado.v1.AgentService.ListAgentCapabilities
 */
export const listAgentCapabilities = AgentService.method.listAgentCapabilities;

/**
 * GetAiOrbConfig returns the platform-wide AI orb visual config. Global,
 * not org-scoped; requires only authentication.
 *
 * @generated from rpc cortado.v1.AgentService.GetAiOrbConfig
 */
export const getAiOrbConfig = AgentService.method.getAiOrbConfig;
